import { FC, useMemo } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { createAppTheme } from 'src/configs/theme';
import { CacheProvider } from '@emotion/react';
import createEmotionCache from 'src/createEmotionCache';
import { ToastContainer } from 'react-toastify';
import Router from './routes/Router';
import { ThemeModeContext } from './components/context/ThemeModeContext';
import { useThemeModeState } from './components/hooks/useThemeModeState';

import 'react-toastify/dist/ReactToastify.min.css';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import 'src/assets/styles/globals.css';

const App: FC = () => {
  const { mode, toggleMode } = useThemeModeState();

  const theme = useMemo(() => createAppTheme(mode), [mode]);

  return (
    <CacheProvider value={createEmotionCache()}>
      <ThemeModeContext.Provider value={{ mode, toggleMode }}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <ToastContainer
            limit={3}
            position="bottom-right"
            newestOnTop
            closeOnClick
            pauseOnHover
            theme={mode === 'dark' ? 'dark' : 'light'}
            toastStyle={{
              borderRadius: 8,
              fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
            }}
          />
          <Router />
        </ThemeProvider>
      </ThemeModeContext.Provider>
    </CacheProvider>
  );
};

export default App;
